import { format } from './utils';

describe('format', () => {
  it('returns empty string for no appId defined', () => {
    expect(format(undefined)).toEqual('');
  });

  it('formats appId', () => {
    expect(format('some-id')).toEqual('some-id');
  });
});
